import { render, staticRenderFns } from "./add.vue?vue&type=template&id=78308ac4&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78308ac4')) {
      api.createRecord('78308ac4', component.options)
    } else {
      api.reload('78308ac4', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=78308ac4&", function () {
      api.rerender('78308ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/lostAndFound/lostManagement/add.vue"
export default component.exports